const heroSwiper = new Swiper('.background-image-swiper', {
    // Optional parameters
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    allowTouchMove: false,
    pagination: {
        el: '#hero-header-swiper-pagination',
        clickable: true,
        type: 'bullets',
    },
});